import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Snackbar, {SnackbarOrigin} from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export enum SnackTypes {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
}

interface SnackbarProps {
  severity: SnackTypes,
  message: string,
  alertDuration: number, 
  snackbarOrigin?: SnackbarOrigin
}

const SnackBar = forwardRef(({ severity, message, alertDuration=5000, snackbarOrigin}: SnackbarProps, ref: any) => {

  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState<SnackbarOrigin>({
    vertical: 'top',
    horizontal: 'right',
  });

  const handleClose = () => setOpen(false);

  useImperativeHandle(ref, () => (
    {
      showSnackbar() {
        setOpen(true)
      },
      handleClose() {
        setOpen(false)
      }
    }
  ))

  useEffect(() => {
    if (snackbarOrigin !== undefined) {
      setPosition(snackbarOrigin)
    }
  }, [snackbarOrigin])

  return (
    <Snackbar open={open} autoHideDuration={alertDuration} onClose={handleClose} anchorOrigin={position}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        { message }
      </Alert>
    </Snackbar>
  );
})

export default SnackBar;